import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { verifyMessage, matchMessage } from './ums/utils';
import { EXPECTED_MESSAGES, useModalFrameReducer } from './useModalFrameReducer';
const Frame = styled.iframe.withConfig({
  displayName: "ModalFrame__Frame",
  componentId: "sc-1yhxv4f-0"
})(["display:", ";top:", "px;height:100%;width:100%;border:0;position:absolute;z-index:9999999;"], props => props.frameReady ? undefined : 'none', props => props.scrollTop);

function ModalFrame({
  src,
  onMessage,
  renderLoadingModal,
  setLoadFrame,
  id
}) {
  const frameRef = useRef(null);
  const scrollTop = useRef(0);
  const [{
    frameReady,
    showParentModal,
    frameDimensions
  }, dispatchFrameAction] = useModalFrameReducer(); // Handle post messages

  useEffect(() => {
    const handlePostMessage = event => {
      if (verifyMessage(frameRef, event)) {
        if (matchMessage(event, 'FRAME_READY')) {
          scrollTop.current = document.documentElement.scrollTop;
        }

        if (matchMessage(event, 'CLOSE_FRAME')) {
          setLoadFrame(false);
        }

        if (matchMessage(event, 'RELOAD_PARENT')) {
          // @ts-expect-error reload only accepts an argument in firefox
          window.location.reload(true);
        }

        if (typeof event.data === 'string' && EXPECTED_MESSAGES.includes(event.data)) {
          dispatchFrameAction({
            type: event.data
          });
        } else if (typeof event.data === 'object' && EXPECTED_MESSAGES.includes(event.data.type)) {
          dispatchFrameAction({
            type: event.data.type,
            payload: Object.assign({}, event.data.dimensions, {}, event.data.data)
          });
        }

        if (onMessage) {
          onMessage(event);
        }
      }
    };

    window.addEventListener('message', handlePostMessage);
    return () => {
      window.removeEventListener('message', handlePostMessage);
    };
  }, [onMessage, dispatchFrameAction, setLoadFrame]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderLoadingModal && renderLoadingModal({
      frameReady,
      modalWidth: frameDimensions.width,
      modalHeight: frameDimensions.height,
      showParentModal,
      wrapContentSize: true
    }), /*#__PURE__*/_jsx(Frame, {
      id: id,
      src: src,
      ref: frameRef,
      frameReady: frameReady,
      scrollTop: scrollTop.current
    })]
  });
}

export default ModalFrame;